(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vovees-decision-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-vovees-scroll-buy]');

    if (!trigger) {
      return;
    }

    const purchaseArea = document.querySelector('product-rerender[id^="product-info-"] buy-buttons');

    if (!purchaseArea) {
      return;
    }

    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    purchaseArea.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });

    window.setTimeout(() => {
      const purchaseButton = purchaseArea.querySelector('button');

      if (purchaseButton) {
        purchaseButton.focus({ preventScroll: true });
      }
    }, reduceMotion ? 0 : 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vovees-faq-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vovees-faq-hub')) {
    customElements.define('vovees-faq-hub', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.input = this.querySelector('input[type="search"]');
        this.clearButton = this.querySelector('.vovees-faq-search__clear');
        this.filters = [...this.querySelectorAll('[data-filter]')];
        this.items = [...this.querySelectorAll('[data-faq-item]')];
        this.status = this.querySelector('.vovees-faq-hub__status');
        this.empty = this.querySelector('.vovees-faq-hub__empty');
        this.resetButton = this.empty.querySelector('button');
        this.expandButton = this.querySelector('.vovees-faq-hub__expand');
        this.activeCategory = 'all';
        this.expanded = false;
        this.normalize = (value) => value.toLocaleLowerCase('it').normalize('NFD').replace(/\p{Diacritic}/gu, '');
        this.items.forEach((item) => { item.dataset.normalizedSearch = this.normalize(item.dataset.search); });
        this.input.closest('form').addEventListener('submit', (event) => event.preventDefault());
        this.input.addEventListener('input', () => this.applyFilters());
        this.clearButton.addEventListener('click', () => {
          this.input.value = '';
          this.input.focus();
          this.applyFilters();
        });
        this.filters.forEach((filter) => filter.addEventListener('click', () => this.setCategory(filter.dataset.filter)));
        this.resetButton.addEventListener('click', () => this.reset());
        this.expandButton.addEventListener('click', () => this.toggleAll());
        this.items.forEach((item) => item.addEventListener('toggle', () => {
          if (!item.open || this.expanded) return;
          this.items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        }));
        this.openHashTarget();
        this.applyFilters();
      }

      setCategory(category) {
        this.activeCategory = category;
        this.filters.forEach((filter) => {
          const active = filter.dataset.filter === category;
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.applyFilters();
      }

      applyFilters() {
        const query = this.normalize(this.input.value.trim());
        let visible = 0;
        this.items.forEach((item) => {
          const categoryMatch = this.activeCategory === 'all' || item.dataset.category === this.activeCategory;
          const searchMatch = query === '' || item.dataset.normalizedSearch.includes(query);
          const show = categoryMatch && searchMatch;
          item.hidden = !show;
          if (!show) item.open = false;
          if (show) visible += 1;
        });
        this.clearButton.hidden = query === '';
        this.empty.hidden = visible !== 0;
        this.status.textContent = `${visible} ${visible === 1 ? this.dataset.singular : this.dataset.plural}`;
      }

      toggleAll() {
        this.expanded = !this.expanded;
        this.items.forEach((item) => {
          if (!item.hidden) item.open = this.expanded;
        });
        this.expandButton.textContent = this.expanded ? this.dataset.collapseLabel : this.dataset.expandLabel;
      }

      reset() {
        this.input.value = '';
        this.setCategory('all');
        this.input.focus();
      }

      openHashTarget() {
        if (!window.location.hash) return;
        const target = this.querySelector(window.location.hash);
        if (target?.matches('[data-faq-item]')) target.open = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
